import styled from 'styled-components';
import { white } from '@avangard/ui/colors';

import { ChatsListItem } from './chats-list-item';
import { ChatEntity } from '@modules/chat/entities';

type ChatsListProps = {
    chats: ChatEntity[];
    onChooseChat: (chatId: string) => void;
};

const ChatsList = (props: ChatsListProps) => {
    const { chats, onChooseChat } = props;

    const handleClick = (chatId: string) => () => onChooseChat(chatId);

    return (
        <Root>
            {chats.map(chat => (
                <ChatsListItem key={chat.id} chat={chat} onClick={handleClick(chat.id)} />
            ))}
        </Root>
    );
};

const Root = styled.div`
    margin: 12px 0;

    > *:not(:last-child) {
        border-bottom: 1px solid ${white[80]};
    }
`;

export { ChatsList };
